import { render, staticRenderFns } from "./SerieNumeroFormMovimientoDispositivos.vue?vue&type=template&id=05b52493&scoped=true&"
import script from "./SerieNumeroFormMovimientoDispositivos.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormMovimientoDispositivos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b52493",
  null
  
)

export default component.exports